// extracted by mini-css-extract-plugin
export default {"form":"MedicoForm_form__41jA8","wrapper":"MedicoForm_wrapper__65vM4","select":"MedicoForm_select__Y7rhe","label":"MedicoForm_label__lhiUK"};